export { default, getServerSideProps } from './B2BOrgLogin';
